import { ActionType, createReducer } from "typesafe-actions";
import * as actions from "store/features/templates/definition/definition.actions";
import {
    createTemplate,
    fetchTemplateDetails,
    updateTemplate,
    validateTemplate,
    clearTemplateDefinition,
} from "store/features/templates/definition/definition.actions";
import { finishFormSubmit, resetApiError } from "store/features/general/general.actions";
import { TemplateDefinition } from "api";

export type GeneralAction = ActionType<typeof actions>;

export type TemplatesDefinitionState = Readonly<{
    isProcessing: boolean;
    isSubmitted: boolean;
    hasError: boolean;
    isValidationSuccessful: boolean;
    validationErrorMessage: string;
    templateDefinition: (TemplateDefinition & { parsedXml: string }) | null;
    templatePreview: string;
}>;

export const templatesDefinitionInitialState: TemplatesDefinitionState = {
    hasError: false,
    isSubmitted: false,
    isProcessing: false,
    isValidationSuccessful: false,
    validationErrorMessage: "",
    templateDefinition: null,
    templatePreview: "",
};

export const definitionReducer = createReducer<TemplatesDefinitionState, GeneralAction>(templatesDefinitionInitialState)
    .handleAction(
        [createTemplate.request, updateTemplate.request, fetchTemplateDetails.request, validateTemplate.request],
        (state) => {
            return {
                ...state,
                isSubmitted: false,
                isValidationSuccessful: false,
                isProcessing: true,
            };
        }
    )
    .handleAction(fetchTemplateDetails.success, (state, { payload }) => {
        return {
            ...state,
            isProcessing: false,
            templateDefinition: payload,
        };
    })
    .handleAction(clearTemplateDefinition as never, (state) => {
        return {
            ...state,
            templateDefinition: null,
        };
    })
    .handleAction([updateTemplate.success, createTemplate.success] as never, (state) => {
        return {
            ...state,
            isProcessing: false,
            isSubmitted: true,
        };
    })
    .handleAction(validateTemplate.success, (state, action) => {
        return {
            ...state,
            isProcessing: false,
            isValidationSuccessful: true,
            templatePreview: action.payload.preview,
        };
    })
    .handleAction(
        [updateTemplate.failure, fetchTemplateDetails.failure, validateTemplate.failure, createTemplate.failure],
        (state, action) => {
            return {
                ...state,
                isProcessing: false,
                validationErrorMessage: action.payload.message || "",
                hasError: true,
            };
        }
    )
    .handleAction(finishFormSubmit as never, () => {
        return templatesDefinitionInitialState;
    })
    .handleAction(resetApiError as never, (state) => {
        return {
            ...state,
            validationErrorMessage: "",
            hasError: false,
        };
    });
